/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ScanBarcodeQrIcon16Light } from './ScanBarcodeQrIcon16Light';
import { ScanBarcodeQrIcon16Regular } from './ScanBarcodeQrIcon16Regular';
import { ScanBarcodeQrIcon16Solid } from './ScanBarcodeQrIcon16Solid';
import { ScanBarcodeQrIcon20Light } from './ScanBarcodeQrIcon20Light';
import { ScanBarcodeQrIcon20Regular } from './ScanBarcodeQrIcon20Regular';
import { ScanBarcodeQrIcon20Solid } from './ScanBarcodeQrIcon20Solid';
import { ScanBarcodeQrIcon24Regular } from './ScanBarcodeQrIcon24Regular';
import { ScanBarcodeQrIcon24Solid } from './ScanBarcodeQrIcon24Solid';
import { ScanBarcodeQrIcon32Regular } from './ScanBarcodeQrIcon32Regular';
import { ScanBarcodeQrIcon64Regular } from './ScanBarcodeQrIcon64Regular';
var sizes = {
    16: {
        light: ScanBarcodeQrIcon16Light,
        regular: ScanBarcodeQrIcon16Regular,
        solid: ScanBarcodeQrIcon16Solid,
    },
    20: {
        light: ScanBarcodeQrIcon20Light,
        regular: ScanBarcodeQrIcon20Regular,
        solid: ScanBarcodeQrIcon20Solid,
    },
    24: {
        regular: ScanBarcodeQrIcon24Regular,
        solid: ScanBarcodeQrIcon24Solid,
    },
    32: {
        regular: ScanBarcodeQrIcon32Regular,
    },
    64: {
        regular: ScanBarcodeQrIcon64Regular,
    },
};
export var ScanBarcodeQrIcon = forwardRef('ScanBarcodeQrIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
